import React, { useContext, useEffect, useState } from 'react';
import './Best.css';
import Item from '../Item/Item';
import { useNav } from '../../Context/NavContext';
import { useProduct } from '../../Context/ProductContext';
import { UrlContext } from '../../Context/UrlContext';

function Best() {

      const { apiBaseUrl } = useContext(UrlContext);

    const { setProductDetails } = useProduct();
    const { setActiveItem } = useNav();

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/products`, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }

                const data = await response.json();
                setProducts(data);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching products:', err);
                setError(err.message);
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const handleClick = (product) => {
        setProductDetails(product);
        setActiveItem('PRODUCT');
        window.scrollTo(0, 0);
    };

    if (loading) {
        return (
            <div className="best_container loading">
                <p>Loading products...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="best_container error">
                <p>Error: {error}</p>
            </div>
        );
    }

    const filteredItems = [...products]
  .sort((a, b) => b.sales_count - a.sales_count) // Sort by highest sales count
  .slice(0, 10); // Take top 10 best-selling products

    return (
        <div className="best_container">
            {filteredItems.length > 0 ? (
                filteredItems.map((product) => (
                    <div key={product.id} className="best_item" onClick={() => handleClick(product)}>
                        <Item
                            image={product.image ? `data:image/jpeg;base64,${product.image}` : null}
                            name={product.name}
                            price={product.price}
                            stock={product.stockCount}
                            sizes={product.sizes}
                        />
                    </div>
                ))
            ) : (
                <div className="no-results">
                    <p>No items match your search criteria.</p>
                </div>
            )}
        </div>
    );
}

export default Best;
